import React from 'react';
import { Breakpoint } from 'react-socks';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import helpOthersIcon from "../../../images/owners/help-others-icon.png";
import easyIcon from "../../../images/owners/easy-icon.png";
import settleIcon from "../../../images/owners/settle-icon.png";

const pitchList = [
  {
    image: helpOthersIcon,
    caption: i18n.t("owners.pitchBanner.helpOthers"),
    alt: "help-others-icon"
  },
  {
    image: easyIcon,
    caption: i18n.t("owners.pitchBanner.easy"),
    alt: "easy-icon"
  },
  {
    image: settleIcon,
    caption: i18n.t("owners.pitchBanner.settle"),
    alt: "settle-icon"
  }
]

const PitchBanner = () => {
  return (
    <div className="w-full bg-[url('./images/owners/pitch-background.png')] bg-center bg-cover bg-no-repeat p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[150px] xl:px-[250px] 2xl:px-[350px]">
      <div className="flex flex-col my-[30px] md:my-[50px]">
        <div className="mb-[20px] text-primary900 text-[35px] font-bold leading-tight md:text-[45px]">{i18n.t("owners.pitchBanner.title")}</div>
        <div className="mb-[20px] text-[14px] text-[#858280] md:text-[16px]">{i18n.t("owners.pitchBanner.description")}
          <a className="mb-[20px] text-[14px] text-[#3F8C83] md:text-[16px]" href="https://www.google.com/search?q=parkit+malaysia"> {i18n.t("owners.pitchBanner.here")}</a>
        </div>
        <div className="flex flex-col items-center my-[10px] lg:flex-row lg:my-[30px] lg:justify-center">
          {pitchList.map((pitch, index) => (
            <div className="flex flex-row items-center" key={`pitch-${index}`}>
              <div className="flex flex-col items-center">
                <div className="w-[200px] flex flex-col items-center">
                  <LazyImage className="w-[120px] h-[120px] mt-[20px] object-contain lg:w-[150px] lg:h-[150px] lg:mt-[0px]" src={pitch.image} alt={pitch.alt} />
                  <div className="w-[180px] mt-[20px] text-[14px] font-bold text-center md:text-[16px]">{pitch.caption}</div>
                </div>
                <Breakpoint customQuery="(max-width: 1023px)">
                  {index !== (pitchList.length - 1) && <FontAwesomeIcon className="mt-[30px] text-primary900 text-[25px]" icon={faChevronDown} />}
                </Breakpoint>
              </div>
              <Breakpoint customQuery="(min-width: 1024px)">
                {index !== (pitchList.length - 1) && <FontAwesomeIcon className="mx-[40px] text-primary900 text-[25px]" icon={faChevronRight} />}
              </Breakpoint>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PitchBanner;